import { useCallback, useEffect, useState } from 'react'

import { MODULE_ADDRESS } from 'config'

import { useCommonConnectStore } from 'components/WalletProvider/store'

const fn = `${MODULE_ADDRESS}::claim::is_user_listed`

const useIsUserListed = (address: string) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isUserListed, setUserListed] = useState(false)

  const client = useCommonConnectStore((state) => state.client)
  const fetchUserListed = useCallback(() => {
    client
      .view({ arguments: [address], function: fn, type_arguments: [] })
      .then((data: boolean[]) => {
        setUserListed(data[0])
      })
      .catch((error) => {
        console.error('Failed to fetch user listed:', error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [address, client])

  useEffect(() => {
    if (client) {
      fetchUserListed()
    }
  }, [client, fetchUserListed])
  return { isLoading, isUserListed }
}
export default useIsUserListed
